<template>
  <div class="page">
    <el-card class="card">
      <div slot="header" class="card-header">
        <span>车辆管理</span>
        <el-button type="primary" icon="el-icon-plus" @click="openAdd">新增车辆</el-button>
      </div>

      <!-- 查询 -->
      <el-form :inline="true" :model="query" class="query-form">
        <el-form-item label="关键字">
          <el-input
            v-model="query.keyword"
            placeholder="车编号/车名称/车牌/司机"
            clearable
            style="width:260px"
            @keyup.enter.native="fetchList"
          />
        </el-form-item>

        <el-form-item label="垃圾类型">
          <el-select v-model="query.garbage_type" placeholder="全部" clearable style="width:140px;">
            <el-option label="废纸" :value="1" />
            <el-option label="塑料" :value="2" />
            <el-option label="衣物" :value="3" />
            <el-option label="废铁" :value="4" />
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width:140px;">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="fetchList">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table :data="list" border stripe v-loading="loading" style="width:100%;">
        <el-table-column prop="vehicle_code" label="车辆编号" width="120" />
        <el-table-column prop="vehicle_name" label="车辆名称" min-width="160" />
        <el-table-column prop="plate_no" label="车牌号" width="120" />

        <el-table-column label="垃圾类型" width="110" align="center">
          <template slot-scope="s">
            <el-tag size="mini">{{ garbageText(s.row.garbage_type) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="driver_name" label="司机" width="100" />
        <el-table-column prop="driver_mobile" label="司机手机号" width="140" />

        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="s">
            <el-tag :type="s.row.status === 1 ? 'success' : 'info'">
              {{ s.row.status === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" min-width="140" />

        <el-table-column label="创建时间" width="170">
          <template slot-scope="s">{{ formatTime(s.row.created_at) }}</template>
        </el-table-column>

        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="s">
            <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
            <el-button type="text" @click="openDetail(s.row)">详情</el-button>
            <el-button type="text" style="color:#ef4444;" @click="onDelete(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pager">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :current-page="page"
          :page-size="pageSize"
          @current-change="p => { page = p; fetchList() }"
          @size-change="s => { pageSize = s; page = 1; fetchList() }"
        />
      </div>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增车辆' : '编辑车辆'"
      :visible.sync="dialogVisible"
      width="720px"
      @closed="onDialogClosed"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="车辆编号" prop="vehicle_code" v-if="dialogMode==='add'">
          <el-input v-model="form.vehicle_code" placeholder="例如：CAR001" />
        </el-form-item>

        <el-form-item label="车辆编号" v-else>
          <el-input v-model="form.vehicle_code" disabled />
        </el-form-item>

        <el-form-item label="车辆名称" prop="vehicle_name">
          <el-input v-model="form.vehicle_name" placeholder="例如：废纸清运车1号" />
        </el-form-item>

        <el-form-item label="车牌号" prop="plate_no">
          <el-input v-model="form.plate_no" placeholder="例如：新E12345" />
        </el-form-item>

        <el-form-item label="垃圾类型" prop="garbage_type">
          <el-select v-model="form.garbage_type" placeholder="请选择" style="width:220px;">
            <el-option label="废纸" :value="1" />
            <el-option label="塑料" :value="2" />
            <el-option label="衣物" :value="3" />
            <el-option label="废铁" :value="4" />
          </el-select>
        </el-form-item>

        <el-form-item label="司机姓名" prop="driver_name">
          <el-input v-model="form.driver_name" placeholder="例如：张三" />
        </el-form-item>

        <el-form-item label="司机手机号" prop="driver_mobile">
          <el-input v-model="form.driver_mobile" placeholder="例如：13800000000" />
        </el-form-item>

        <!-- 密码字段 -->
        <el-form-item
          :label="dialogMode === 'add' ? '登录密码' : '登录密码(可选)'"
          prop="password"
        >
          <el-input
            v-model="form.password"
            :placeholder="dialogMode === 'add' ? '例如：123456' : '不修改就留空'"
            show-password
            autocomplete="new-password"
          />
          <div class="pwd-tip">
            用途：H5 端车辆登录/身份校验。编辑时如不需要改密码请留空。
          </div>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :rows="3" v-model="form.remark" placeholder="备注信息" />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSubmit">
          {{ dialogMode === 'add' ? '确认新增' : '确认保存' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="车辆详情" :visible.sync="detailVisible" width="650px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="车辆编号">{{ detail.vehicle_code || '-' }}</el-descriptions-item>
        <el-descriptions-item label="车辆名称">{{ detail.vehicle_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="车牌号">{{ detail.plate_no || '-' }}</el-descriptions-item>
        <el-descriptions-item label="垃圾类型">{{ garbageText(detail.garbage_type) }}</el-descriptions-item>
        <el-descriptions-item label="司机">{{ detail.driver_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="司机手机号">{{ detail.driver_mobile || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detail.status === 1 ? 'success' : 'info'">
            {{ detail.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detail.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div style="margin-top:12px;color:#94a3b8;font-size:12px;">
        密码不在详情里展示（安全），如需修改请在编辑里填“登录密码”。
      </div>

      <span slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVehicleList,
  createVehicle,
  updateVehicle,
  deleteVehicle,
  getVehicleDetail
} from '@/api/vehicle'

export default {
  name: 'VehicleList',
  data() {
    return {
      loading: false,
      saving: false,

      query: {
        keyword: '',
        garbage_type: undefined,
        status: undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      list: [],

      dialogVisible: false,
      dialogMode: 'add',
      currentId: null,

      form: {
        vehicle_code: '',
        vehicle_name: '',
        plate_no: '',
        garbage_type: 1,
        driver_name: '',
        driver_mobile: '',
        password: '',
        status: 1,
        remark: ''
      },

      rules: {
        vehicle_code: [{ required: true, message: '请输入车辆编号', trigger: 'blur' }],
        vehicle_name: [{ required: true, message: '请输入车辆名称', trigger: 'blur' }],
        plate_no: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
        garbage_type: [{ required: true, message: '请选择垃圾类型', trigger: 'change' }],
        driver_name: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }],
        driver_mobile: [
          { required: true, message: '请输入司机手机号', trigger: 'blur' },
        //   { pattern: /^1\\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        password: [
          {
            validator: (rule, val, cb) => {
              if (this.dialogMode === 'add') {
                if (!val || !String(val).trim()) return cb(new Error('请输入登录密码'))
                if (String(val).trim().length < 4) return cb(new Error('密码至少 4 位'))
              } else {
                if (val && String(val).trim() && String(val).trim().length < 4) {
                  return cb(new Error('密码至少 4 位'))
                }
              }
              cb()
            },
            trigger: 'blur'
          }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },

      detailVisible: false,
      detail: {}
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    garbageText(v) {
      const map = { 1: '废纸', 2: '塑料', 3: '衣物', 4: '废铁' }
      return map[v] || '-'
    },
    formatTime(ts) {
      if (!ts) return '-'
      const d = new Date(ts * 1000)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },

    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.page, page_size: this.pageSize }
        if (this.query.keyword) params.keyword = this.query.keyword.trim()
        if (this.query.garbage_type >= 1 && this.query.garbage_type <= 4) params.garbage_type = this.query.garbage_type
        if (this.query.status === 0 || this.query.status === 1) params.status = this.query.status

        const res = await getVehicleList(params)
        this.list = res.items || []
        this.total = res.total || 0
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('getVehicleList failed:', e)
      } finally {
        this.loading = false
      }
    },

    reset() {
      this.query = { keyword: '', garbage_type: undefined, status: undefined }
      this.page = 1
      this.fetchList()
    },

    openAdd() {
      this.dialogMode = 'add'
      this.currentId = null
      this.dialogVisible = true
      this.form = {
        vehicle_code: '',
        vehicle_name: '',
        plate_no: '',
        garbage_type: 1,
        driver_name: '',
        driver_mobile: '',
        password: '',
        status: 1,
        remark: ''
      }
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },

    openEdit(row) {
      this.dialogMode = 'edit'
      this.currentId = row.id
      this.dialogVisible = true
      this.form = {
        vehicle_code: row.vehicle_code || '',
        vehicle_name: row.vehicle_name || '',
        plate_no: row.plate_no || '',
        garbage_type: row.garbage_type || 1,
        driver_name: row.driver_name || '',
        driver_mobile: row.driver_mobile || '',
        password: '',
        status: row.status ?? 1,
        remark: row.remark || ''
      }
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },

    onDialogClosed() {
      this.saving = false
    },

    onSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          if (this.dialogMode === 'add') {
            await createVehicle({
              vehicle_code: this.form.vehicle_code.trim(),
              vehicle_name: this.form.vehicle_name.trim(),
              plate_no: this.form.plate_no.trim(),
              garbage_type: this.form.garbage_type,
              driver_name: this.form.driver_name.trim(),
              driver_mobile: this.form.driver_mobile.trim(),
              status: this.form.status,
              remark: (this.form.remark || '').trim(),
              password: String(this.form.password || '').trim()
            })
            this.$message.success('新增成功')
          } else {
            const payload = {
              vehicle_name: this.form.vehicle_name.trim(),
              plate_no: this.form.plate_no.trim(),
              garbage_type: this.form.garbage_type,
              driver_name: this.form.driver_name.trim(),
              driver_mobile: this.form.driver_mobile.trim(),
              status: this.form.status,
              remark: (this.form.remark || '').trim()
            }
            const pwd = String(this.form.password || '').trim()
            if (pwd) payload.password = pwd

            await updateVehicle(this.currentId, payload)
            this.$message.success('保存成功')
          }

          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn('save vehicle failed:', e)
        } finally {
          this.saving = false
        }
      })
    },

    onDelete(row) {
      this.$confirm(`确定删除车辆【${row.vehicle_code} - ${row.vehicle_name}】吗？`, '删除确认', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      })
        .then(async () => {
          await deleteVehicle(row.id)
          this.$message.success('删除成功')
          if (this.list.length === 1 && this.page > 1) this.page -= 1
          this.fetchList()
        })
        .catch(() => {
          // 用户取消也会走这里，留注释避免 no-empty
          // noop
        })
    },

    async openDetail(row) {
      this.detailVisible = true
      this.detail = {}
      try {
        const res = await getVehicleDetail(row.id)
        this.detail = res || {}
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('getVehicleDetail failed:', e)
      }
    }
  }
}
</script>

<style scoped>
.card-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.query-form{
  margin-bottom:10px;
}
.pager{
  margin-top:12px;
  text-align:right;
}
.pwd-tip{
  margin-top:6px;
  font-size:12px;
  color:#94a3b8;
}
</style>